import { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Input,
  Select,
  Alert,
  notification,
  InputNumber,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllCompanyNames,
  setAllDepartmentNames,
  setAllPositionNames,
} from "../../redux/actions/mainAction";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const AddEmployee = () => {
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  const [employeeName, setEmployeeName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [positionName, setPositionName] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [employeePhone, setEmployeePhone] = useState();
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [appRole, setAppRole] = useState("User");
  const employeeImage = "https://cdn.worldvectorlogo.com/logos/react-1.svg";

  const [showAlert, setShowAlert] = useState(false);
  const [showAlertIncorrectEmail, setShowAlertIncorrectEmail] = useState(false);
  const [showAlertForPass, setShowAlertForPass] = useState(false);
  const [showAlertForPasslength, setShowAlertForPasslength] = useState(false);
  const [showAlertForAvailableEmail, setShowAlertForAvailableEmail] =
    useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    getAllCompanyNames();
    getAllDepartmentNames();
    getAllPositionNames();
  }, [GlobalResponse.triggeranyevent]);

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "İstifadəçi əlavə edildi!",
    });
  };

  const getAllCompanyNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-company-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllCompanyNames(uniqueResults));
  };

  const getAllDepartmentNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-department-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllDepartmentNames(uniqueResults));
  };

  const getAllPositionNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-position-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllPositionNames(uniqueResults));
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const handleChangeDepartment = (value) => {
    setDepartmentName(value);
  };

  const handleChangePosition = (value) => {
    setPositionName(value);
  };

  const prepareToSave = () => {
    if (isValidEmail(employeeEmail)) {
      if (
        employeeName &&
        companyName &&
        positionName &&
        departmentName &&
        employeeEmail &&
        employeePhone &&
        password &&
        repeatPassword
      ) {
        checkPasswordLength();
        setShowAlert(false);
      } else {
        setShowAlert(true);
      }
    } else {
      setShowAlertIncorrectEmail(true);
    }
  };

  const checkPasswordLength = () => {
    if (password.length > 5) {
      setShowAlertForPasslength(false);
      saveEmployee();
    } else {
      setShowAlertForPasslength(true);
    }
  };

  const saveEmployee = async () => {
    try {
      if (password === repeatPassword) {
        setButtonDisable(true);
        setShowAlertForPass(false);

        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/add-employee/`,
          {
            method: "post",
            body: JSON.stringify({
              employeeName,
              employeeImage,
              companyName,
              positionName,
              departmentName,
              employeeEmail,
              employeePhone,
              password,
              appRole,
            }),
            headers: {
              "Content-Type": "application/json",
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );

        if (result.ok) {
          dispatch(setTriggerAnyEvent(Math.random()));
          setEmployeeName("");
          setCompanyName("");
          setDepartmentName("");
          setPositionName("");
          setEmployeeEmail("");
          setEmployeePhone("");
          setPassword("");
          setRepeatPassword("");
          setShowAlertForAvailableEmail(false);
          setShowAlertIncorrectEmail(false);
          openNotificationWithIcon("success");
          setButtonDisable(false);
        } else {
          setShowAlertForAvailableEmail(true);
        }
      } else {
        setShowAlertForPass(true);
      }
    } catch (error) {
      console.log("Səhv!");
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      {contextHolder}

      {showAlertIncorrectEmail && (
        <Alert
          onClose={() => setShowAlertIncorrectEmail(false)}
          message="Diqqət!"
          description="E-poçt hesabında səhv var!"
          type="warning"
          showIcon
          closable
        />
      )}

      {showAlertForAvailableEmail && (
        <Alert
          onClose={() => setShowAlertForAvailableEmail(false)}
          message="Diqqət!"
          description="Bu e-poçt hesabı artıq qeydiyyatdan keçirilib!"
          type="warning"
          showIcon
          closable
        />
      )}

      {showAlertForPasslength && (
        <Alert
          onClose={() => setShowAlertForPasslength(false)}
          message="Diqqət!"
          description="Şifrələr 5 simvoldan çox olmalıdır!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertForPass && (
        <Alert
          onClose={() => setShowAlertForPass(false)}
          message="Diqqət!"
          description="Şifrələriniz eyni deyil!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}

      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Ad və soyad</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={employeeName}
            onChange={(e) => setEmployeeName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            value={companyName}
            onChange={handleChangeCompany}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şöbə</Typography.Text>

          <Select
            size="large"
            value={departmentName}
            onChange={handleChangeDepartment}
            className="add-dropdown"
            options={MainResponse.allDepartmentNames}
          />
        </Col>

        <Col span={6}>
          <Typography.Text className="add-title">Vəzifə</Typography.Text>

          <Select
            size="large"
            value={positionName}
            onChange={handleChangePosition}
            className="add-dropdown"
            options={MainResponse.allPositionNames}
          />
        </Col>
      </Row>

      <Row className="add-row">
        <Col span={5}>
          <Typography.Text className="add-title">E-poçt</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={employeeEmail}
            onChange={(e) =>
              setEmployeeEmail(e.target.value.toLowerCase().trim())
            }
          />
        </Col>

        <Col span={5}>
          <Typography.Text className="add-title">Telefon</Typography.Text>
          <InputNumber
            className="add-input"
            size="large"
            onChange={(e) => setEmployeePhone(e)}
            value={employeePhone}
          />
        </Col>

        <Col span={5}>
          <Typography.Text className="add-title">Şifrə</Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={5}>
          <Typography.Text className="add-title">
            Şifrənin təkrarı
          </Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={4}>
          <button
            disabled={buttonDisable}
            onClick={prepareToSave}
            className="add-button"
          >
            Əlavə Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default AddEmployee;
